import AdminPage from "@/pages/settings/admin/page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_pathlessLayout/settings/admin")({
    component: AdminPage,
});
